import { S3Client } from '@aws-sdk/client-s3';
import supabase from './supabaseClient';

export const getS3Client = async () => {
  // Get current session
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) throw error;

  // Extract project reference from Supabase URL
  const projectRef = process.env.REACT_APP_SUPABASE_PROJECT_ID;

  return new S3Client({
    forcePathStyle: true,
    region: 'us-west-1', // Supabase default region
    endpoint: `https://xhshxsntdcyvxjkjxpmw.supabase.co/storage/v1/s3`,
    credentials: {
      accessKeyId: projectRef,
      secretAccessKey: process.env.REACT_APP_SUPABASE_KEY,
      sessionToken: session.access_token,
    },
  });
};

// Helper function to refresh the client when token expires
export const refreshS3Client = async () => {
  const { data: { session }, error } = await supabase.auth.refreshSession();
  if (error) throw error;
  return getS3Client();
}; 